import { API } from "./apiClient";

export const apiAddToCart = async (itemDetails) => {
  try {
    const payload = { item: itemDetails };
    const res = await API.post("/addtocart", payload);
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to add to cart");
  }
};

export const apiFetchCart = async () => {
  try {
    const res = await API.get("/cart");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to fetch cart");
  }
};

export const apiGetCartTotal = async () => {
  try {
    const res = await API.get("/cart/gettotal");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to get cart total");
  }
};

export const apiClearCart = async () => {
  try {
    const res = await API.delete("/cart/clearcart");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to clear cart");
  }
};

export const apiRemoveFromCart = async (productId) => {
  try {
    const res = await API.delete(`/cart/removefromcart/${productId}`);
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to remove from cart");
  }
};

export const apiFetchCartItems = async () => {
  try {
    const res = await API.get("/cart/items");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to fetch cart items");
  }
};

export const apiGetCartTotalCount = async () => {
  try {
    const res = await API.get("/cart/totalcount");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to get cart total count");
  }
};

export const apiGetShippingOptions = async () => {
  try {
    const res = await API.get("/getshippingoptions");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to get shipping options");
  }
};

export const apiGetOrderTotal = async () => {
  try {
    const res = await API.get("/ordertotal");
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to get order total");
  }
};

export const apiPlaceOrder = async (payload) => {
  try {
    const res = await API.post("/placeorder", payload);
    return res.data;
  } catch (err) {
    throw new Error(err.response?.data?.message || "Failed to place order");
  }
};
export const apiGetMyRewards = async () => {
  try {
    const res = await API.get("/reward/myrewards");
    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "Failed to fetch rewards"
    );
  }
};
export const apiApplyCoupon = async (payload) => {
  try {
    const res = await API.post("/cart/applycoupon", payload);
    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message || "Failed to apply coupon"
    );
  }
};
